export const activity = {
  activityWebEmptyStateTitle: '활동 없음',
  activityWebEmptyStateText: '여기에 알림이 표시됩니다',
  activitySeeAll: '모두 보기',
  in: '에서'
}
